import { h, FunctionalComponent } from "preact";

interface Props {
  breadcrumb: string[];
  url: string;
  title: string;
  onClick?: () => void;
}

const QuestionInlineView: FunctionalComponent<Props> = props => (
  <a href={props.url} onClick={props.onClick} className="questionInlineView">
    <ol className="questionInlineView__breadcrumb">
      {props.breadcrumb.map(section => (
        <li className="questionInlineView__breadcrumb_item">
          <span>{section}</span>
        </li>
      ))}
    </ol>
    <p className="questionInlineView__title">{props.title}</p>
  </a>
);

export default QuestionInlineView;
